module.exports = __webpack_public_path__ + "img/Icon-download-w.69a32d63.svg";